import { Dispatch, SetStateAction, useEffect, useState  } from "react";
import { IFilters } from "../FinancialTransactionsReport";
import s from './index.module.css'
import { directionOrdersApi } from "@/api";
import Select from "@UI/New/Select";
import { filterOptionsByLabel } from "@/helpers/new/filterOptionsByLabel";
import { useAddAlert } from "@/hooks/useAddAlert";

interface FinancialTransactionsReportFiltersProps {
  filters: IFilters;
  setFilters: Dispatch<SetStateAction<IFilters>>;
  userId: number;
}
interface IOption {
  value: string | number;
  label: string;
}

export const FinancialTransactionsReportFilters = ({filters, setFilters, userId}: FinancialTransactionsReportFiltersProps) => {
    const addAlert = useAddAlert()
    const [options, setOptions] = useState<IOption[]>([]);
    const [balanceOptions, setBalanceOptions] = useState<IOption[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    
    useEffect(() => {
        if(!userId) {
            addAlert({title: 'Ошибка', text: 'Курсы для фильтра не загружены, не передан id учащегося', type: 'error'})
            return
        };
        setLoading(true)
        directionOrdersApi.getHistoryForSelect({id: userId})
            .then(({data})=>{
                if(data?.status === 'success'){
                    const items: IOption[] = data?.data ?? []
                    setOptions(items.filter((item) => !String(item.value).startsWith('additional:')))
                    setBalanceOptions(items.filter((item) => String(item.value).startsWith('additional:')))
                }
                else{
                    setOptions([])
                    setBalanceOptions([])
                    addAlert({title: 'Ошибка', text: 'При загрузке курсов для фильтра произошла ошибка', type: 'error'})
                }
            })
            .finally(() => setLoading(false))
    }, [userId])

    const fieldsAllCourses = {
        loading,
        showSearch: true,
        allowClear: true,
        filterOption: filterOptionsByLabel,
        onChange: (e: number | string) => setFilters(prev => ({...prev, directionId: e || null, balanceId: e ? null : prev.balanceId})),
        options: options,
        value: filters.directionId,
        placeholder: 'Курс',
        notFoundContent: "Курсы не найдены" 
    };
    const balanceFields = {
        loading,
        showSearch: true,
        allowClear: true,
        filterOption: filterOptionsByLabel,
        onChange: (e: string) => setFilters(prev => ({...prev, balanceId: e || null, directionId: e ? null : prev.directionId})),
        options: balanceOptions,
        value: filters.balanceId,
        placeholder: 'Баланс',
        notFoundContent: 'Балансы не найдены',
    };
    const statusFields = {
        allowClear: true,
        onChange: (status: string) =>
            setFilters((prev) => ({ ...prev, status: status || null })),
        options: [
            { value: 'paid', label: 'Оплачено' },
            { value: 'withdrawn', label: 'Списано' },
            { value: 'refunded', label: 'Возвращено' },
            { value: 'accrued', label: 'Начислено' },
        ],
        value: filters.status,
        placeholder: 'Статус',
    };
    
    return (
        <div className={s.wrapper}>
            <Select
                compact
                hideSearchIcon
                wrapperClassName={s.wrapperSelect} 
                className={s.select} 
                fields={fieldsAllCourses} 
            />
            <Select
                compact
                hideSearchIcon
                wrapperClassName={s.wrapperSelect}
                className={s.select}
                fields={statusFields}
            />
            <Select
                compact
                hideSearchIcon
                wrapperClassName={s.wrapperSelect}
                className={s.select}
                fields={balanceFields}
            />
        </div>
    )
}
